import { ProjectStatusTypeEnum } from '@zaoblako/shared/modules/project/enum/project.status.type.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';

import * as yup from 'yup';

/** Project status response body - DTO signature */
export interface StatusFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Status display name */
  name: string;
  /** Status color - hex triplet of Web Color (string like `#aabbcc`). Optional value. */
  color?: string;
  /** Project creation date and time */
  created: Date;
  /** Project last update date and time */
  updated: Date;
  /** Is project deleted */
  deleted: boolean;
  /** Is this status final (project become complete with this status) */
  isFinal: boolean;
  /** Status system type */
  type: ProjectStatusTypeEnum;
}

/** Project status response body - DTO schema */
export const StatusFindDto = SerdeDtoClass.create<StatusFindInterface>(ProjectDtoKeysEnum.STATUS_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: yup.string(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    label: 'Удален',
    serializer: yup.boolean(),
  },
  isFinal: {
    label: 'Завершающий статус',
    serializer: yup.boolean(),
  },
  type: {
    sortable: true,
    label: 'Тип',
    serializer: yup
      .string()
      .oneOf(Object.values(ProjectStatusTypeEnum)),
  },
});
